import { Box, Typography } from "@material-ui/core";
import { useState, useEffect } from "react";
import useStyles from '../../../assets/styles/styles';
import {useSelector } from "react-redux";



const DetailVitalSigns = () => {
    const classes = useStyles();
    const modelVitalSignsReducer = useSelector(state => state.appointmentsReducer);
    const modelVitalSigns = modelVitalSignsReducer?.vitalSigns;
    const [isMobile, setIsMobile] = useState(window.innerWidth < 760);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 760);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const laboratoryDate = modelVitalSigns?.[0]?.fechaFormateada
        ? new Date(modelVitalSigns[0].fechaFormateada).toLocaleDateString('es-ES')
        : "";

    const fields = [
        {
            label: "Presión Sistólica",
            value: modelVitalSigns?.[0]?.resultados?.find(item => item.nombre === "Presión Sistólica")
                ? `${modelVitalSigns[0].resultados.find(item => item.nombre === "Presión Sistólica").valor} ${modelVitalSigns[0].resultados.find(item => item.nombre === "Presión Sistólica").unidad}`
                : null,
            condition: !!modelVitalSigns?.[0]?.resultados?.find(item => item.nombre === "Presión Sistólica")?.valor,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "Presión Diastólica",
            value: modelVitalSigns?.[0]?.resultados?.find(item => item.nombre === "Presión Diastólica")
                ? `${modelVitalSigns[0].resultados.find(item => item.nombre === "Presión Diastólica").valor} ${modelVitalSigns[0].resultados.find(item => item.nombre === "Presión Diastólica").unidad}`
                : null,
            condition: !!modelVitalSigns?.[0]?.resultados?.find(item => item.nombre === "Presión Diastólica")?.valor,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "Presión Media",
            value: modelVitalSigns?.[0]?.resultados?.find(item => item.nombre === "Presión Media")
                ? `${modelVitalSigns[0].resultados.find(item => item.nombre === "Presión Media").valor} ${modelVitalSigns[0].resultados.find(item => item.nombre === "Presión Media").unidad}`
                : null,
            condition: !!modelVitalSigns?.[0]?.resultados?.find(item => item.nombre === "Presión Media")?.valor,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "FR. Respiratoria",
            value: modelVitalSigns?.[0]?.resultados?.find(item => item.nombre === "Frecuencia Respiratoria")
                ? `${modelVitalSigns[0].resultados.find(item => item.nombre === "Frecuencia Respiratoria").valor} ${modelVitalSigns[0].resultados.find(item => item.nombre === "Frecuencia Respiratoria").unidad}`
                : null,
            condition: !!modelVitalSigns?.[0]?.resultados?.find(item => item.nombre === "Frecuencia Respiratoria")?.valor,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "FR. Cardíaca",
            value: modelVitalSigns?.[0]?.resultados?.find(item => item.nombre === "Frecuencia Cardíaca")
                ? `${modelVitalSigns[0].resultados.find(item => item.nombre === "Frecuencia Cardíaca").valor} ${modelVitalSigns[0].resultados.find(item => item.nombre === "Frecuencia Cardíaca").unidad}`
                : null,
            condition: !!modelVitalSigns?.[0]?.resultados?.find(item => item.nombre === "Frecuencia Cardíaca")?.valor,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
        {
            label: "Temperatura",
            value: modelVitalSigns?.[0]?.resultados?.find(item => item.nombre === "Temperatura")
                ? `${modelVitalSigns[0].resultados.find(item => item.nombre === "Temperatura").valor} ${modelVitalSigns[0].resultados.find(item => item.nombre === "Temperatura").unidad}`
                : null,
            condition: !!modelVitalSigns?.[0]?.resultados?.find(item => item.nombre === "Temperatura")?.valor,
            valueStyle: classes.detailsAccordionChronic,
            labelClass: classes.txtDescriptionDetailEvolution,
        },
    ];

    const splitText = (text, wordLimit) => {
        if (typeof text !== 'string') return [];
        const descriptionEvolution = text.split(' ');
        const result = [];
        let currentLine = [];
        descriptionEvolution.forEach((word) => {
            currentLine.push(word);
            if (currentLine.length >= wordLimit) {
                result.push(currentLine.join(' '));
                currentLine = [];
            }
        });

        if (currentLine.length > 0) {
            result.push(currentLine.join(' '));
        }
        return result;
    };

    return (
        <>
            <Box className={`${classes.boxContent}`}>
                <>
                    <Box style={{ marginBottom: '10px' }}>
                        <Typography className={`${classes.txtCardDescription} ${classes.titleDetailLaboratory}`}>
                            SIGNOS VITALES {laboratoryDate && `| ${laboratoryDate}`}
                        </Typography>
                    </Box>

                    {fields.map((field, index) => (
                        field.condition && (
                            <Box key={index} style={{ marginBottom: "10px" }}>
                                <Typography className={field.labelClass}>{field.label}</Typography>
                                {isMobile
                                    ? splitText(field.value, 6).map((line, lineIndex) => (
                                        <Typography key={lineIndex} className={field.valueStyle}>{line}</Typography>
                                    ))
                                    : <Typography className={field.valueStyle}>{field.value}</Typography>
                                }
                               
                            </Box>
                        )
                    ))}
                </>
            </Box>
        </>
    );
};

export default DetailVitalSigns;
